import React from "react";
import { Loader2 } from "lucide-react";
import { ModalShell } from "./helpers.js";

export default function ProjectFormModal({ show, onClose, editingProject, projectFormData, setProjectFormData, customers, projectStatusConfig, saving, onSubmit }) {
  if (!show) return null;

  return (
    <ModalShell
      title={editingProject ? "Modifier le projet" : "Créer un projet"}
      subtitle="Renseigne les infos du projet"
      onClose={onClose}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label className="text-sm font-semibold text-slate-900">Client *</label>
            <select
              required
              value={projectFormData.customer_id}
              onChange={(e) => setProjectFormData({ ...projectFormData, customer_id: e.target.value })}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-300 focus:ring-4 focus:ring-slate-100"
            >
              <option value="">Sélectionner un client</option>
              {customers.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.name} {c.phone ? `- ${c.phone}` : ""}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-900">Statut</label>
            <select
              value={projectFormData.status}
              onChange={(e) => setProjectFormData({ ...projectFormData, status: e.target.value })}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-300 focus:ring-4 focus:ring-slate-100"
            >
              {Object.entries(projectStatusConfig).map(([k, v]) => (
                <option key={k} value={k}>{v.label}</option>
              ))}
            </select>
          </div>
        </div>

        <div>
          <label className="text-sm font-semibold text-slate-900">Titre *</label>
          <input
            required
            value={projectFormData.title}
            onChange={(e) => setProjectFormData({ ...projectFormData, title: e.target.value })}
            className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-300 focus:ring-4 focus:ring-slate-100"
            placeholder="Ex: Installation ERP, Refonte site…"
          />
        </div>

        <div>
          <label className="text-sm font-semibold text-slate-900">Description</label>
          <textarea
            value={projectFormData.description}
            onChange={(e) => setProjectFormData({ ...projectFormData, description: e.target.value })}
            className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-300 focus:ring-4 focus:ring-slate-100"
            rows={3}
            placeholder="Objectifs, contexte, notes…"
          />
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <label className="text-sm font-semibold text-slate-900">Date début</label>
            <input
              type="date"
              value={projectFormData.start_date}
              onChange={(e) => setProjectFormData({ ...projectFormData, start_date: e.target.value })}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-300 focus:ring-4 focus:ring-slate-100"
            />
          </div>
          <div>
            <label className="text-sm font-semibold text-slate-900">Date fin</label>
            <input
              type="date"
              value={projectFormData.end_date}
              onChange={(e) => setProjectFormData({ ...projectFormData, end_date: e.target.value })}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none focus:border-slate-300 focus:ring-4 focus:ring-slate-100"
            />
          </div>
        </div>

        <div className="flex gap-3 pt-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-900 hover:bg-slate-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            disabled={saving}
            className="flex-1 rounded-2xl bg-slate-900 px-4 py-2.5 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-70 inline-flex items-center justify-center gap-2"
          >
            {saving
              ? <><Loader2 className="h-4 w-4 animate-spin" />Enregistrement…</>
              : editingProject ? "Mettre à jour" : "Créer"
            }
          </button>
        </div>
      </form>
    </ModalShell>
  );
}
